/**
 * @file MobileAppCta/constants.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 * @author Avi Craimer [avi.craimer@gmail.com]
 */

// iOS Values
export const IOS_DEEPLINK = "cbcnews://";
export const APPLE_STORE =
    "https://apps.apple.com/app/apple-store/id417988800?pt=63436&ct=MobileAppCta&mt=8";

// Android Values
export const PLAY_STORE =
    "https://play.google.com/store/apps/details?id=ca.cbc.mobile.android.cbcnewsandroidwebview&referrer=utm_source%3DMobileAppCta";
export const ANDROID_DEEPLINK = "https://www.cbc.ca/";

export const AUDIENCE_SEGMENT = "756657";
